import { render, staticRenderFns } from "./error-page.vue?vue&type=template&id=1f3ee450&scoped=true&"
import script from "./error-page.vue?vue&type=script&lang=js&"
export * from "./error-page.vue?vue&type=script&lang=js&"
import style0 from "./error-page.vue?vue&type=style&index=0&id=1f3ee450&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f3ee450",
  null
  
)

export default component.exports